/* IE8 Dropdown width issue fix */
function ResetWidth(drpLst) {
    drpLst.style.width = '150px';
}